import React from "react";
import { ShareApplicationPerson } from "@/types/ShareApplication";
import { InviteEmailButton } from "../InviteEmailButton";
import { CopyUrlComponent } from "../CopyUrlComponent";
import "./InviteSentAccountComponent.scss";

export interface InviteSentAccountComponentProps {
  person: ShareApplicationPerson;
  financialApplicationId?: string;
}

export const InviteSentAccountComponent: React.FC<InviteSentAccountComponentProps> = ({
  person,
  financialApplicationId,
}) => {
  return (
    <div className="invite-sent-account-component">
      <h3>Share Application with {person.fullName}</h3>
      <p>
        An invite has been sent to this person. You can also copy and share the invite link below if
        needed.
      </p>

      {person.validInviteLink ? (
        <>
          <CopyUrlComponent
            url={person.validInviteLink}
            label="Invite Link"
            description="Copy this link to share with the person (invite already sent)"
          />

          <div className="invite-sent-account-component__send-email-section">
            <InviteEmailButton
              person={person}
              financialApplicationId={financialApplicationId}
              buttonText="Re-send Invite Email"
              isReSend={true}
            />
          </div>
        </>
      ) : (
        <div className="invite-sent-account-component__no-link">
          <p>Invite has been sent. No additional link available.</p>
        </div>
      )}
    </div>
  );
};

export default InviteSentAccountComponent;
